module.exports = __webpack_public_path__ + "static/media/review-img2.ec04eb0e.png";